import { render, staticRenderFns } from "./iconAddresses.vue?vue&type=template&id=5f4713c0&scoped=true"
import script from "./iconAddresses.vue?vue&type=script&lang=js"
export * from "./iconAddresses.vue?vue&type=script&lang=js"
import style0 from "./iconAddresses.vue?vue&type=style&index=0&id=5f4713c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4713c0",
  null
  
)

export default component.exports